import SpinCentered from '@/comp/SpinCentered';
import { permissions } from '@/constants';
import { useStores } from '@/hooks/use-stores';
import { Popconfirm, Switch } from 'antd';
import { t } from 'i18next';
import { isNil } from 'lodash';
import { observer } from 'mobx-react';
import { useState } from 'react';

const MaintenanceToggle = observer(({ deviceId, inMaintenance }: { deviceId: string; inMaintenance: boolean }) => {
  const { controlCenterStore, permissionStore } = useStores();
  const [isMaintenanceLoading, setIsMaintenanceLoading] = useState(false);
  const [maintenanceMessage, setMaintenanceMessage] = useState('');

  const maintenanceSwitchDisabled =
    isMaintenanceLoading || !permissionStore.isAuth(permissions.UPDATE_DEVICE_MAINTENANCE);

  const onMoveToMaintenance = async () => {
    try {
      setIsMaintenanceLoading(true);
      await controlCenterStore.setMaintenance(deviceId, !inMaintenance);
    } finally {
      setIsMaintenanceLoading(false);
    }
  };

  const handleVisibleChange = async visible => {
    setIsMaintenanceLoading(true);
    if (visible) {
      const maintenanceMessage = await controlCenterStore.fetchMaintenanceMessage(deviceId, inMaintenance);
      setMaintenanceMessage(maintenanceMessage);
    }
    setIsMaintenanceLoading(false);
  };

  return (
    !isNil(inMaintenance) && (
      <div className="flex-row-container">
        <span>{t('moveToMaintenance')}</span>
        <Popconfirm
          onOpenChange={handleVisibleChange}
          placement="top"
          title={isMaintenanceLoading ? <SpinCentered className="spinner" /> : maintenanceMessage}
          onConfirm={onMoveToMaintenance}
          okText={t('Yes')}
          cancelText={t('Cancel')}
          icon={null}
          disabled={maintenanceSwitchDisabled}
        >
          <Switch checked={inMaintenance} disabled={maintenanceSwitchDisabled} />
        </Popconfirm>
      </div>
    )
  );
});

export default MaintenanceToggle;
